// ============================================
// components/common/LoadingSpinner.js
// ============================================
import React from 'react';
import { CircularProgress, Box } from '@mui/material';

const LoadingSpinner = ({ fullScreen = false, size = 40 }) => {
  if (fullScreen) {
    return (
      <Box
        sx={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100vw',
          height: '100vh',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          backgroundColor: 'rgba(0, 0, 0, 0.1)',
          zIndex: 9999
        }}
        minHeight="100vh"
      >
        <CircularProgress data-testid="loading-spinner" size={size} />
      </Box>
    );
  }

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        padding: 2
      }}
    >
      <CircularProgress data-testid="loading-spinner" size={size} />
    </Box>
  );
};

export default LoadingSpinner;